import PropTypes from 'prop-types';
import React from 'react';

import hImage from '../../assets/img/components/User/Login/pw-background-plane-shiny.png';

class FriendProfileHeader extends React.Component {
  componentDidMount() {
    this.props.loadFriendHeader();
  }

  render() {
    let buttonClass;
    let buttonLabel;
    if (this.props.friendInformation.friend) {
      buttonClass =
        'btn btn-outline-download bg-transparent rounded-lg my-auto friend';
      buttonLabel = 'REMOVE FRIEND';
    } else {
      if (this.props.friendInformation.requestPending) {
        buttonClass =
          'btn btn-outline-download bg-transparent rounded-lg my-auto request-pending';
        buttonLabel = 'FRIEND REQUEST PENDING';
      } else {
        buttonClass =
          'btn btn-outline-download bg-transparent rounded-lg my-auto';
        buttonLabel = 'SEND FRIEND REQUEST';
      }
    }
    return (
      <div className="dashboard-header-container friend-header py-5">
        <div className="information-section">
          <div className="avatar-container d-flex">
            {this.props.friendInformation.avatarUrl !== '' &&
            this.props.friendInformation.avatarUrl !== null &&
            this.props.friendInformation.avatarUrl !== 'undefined' ? (
              <img
                alt="..."
                src={hImage}
                className="m-auto avatar-image"
                height="118"
                width="118"
              />
            ) : (
              <i className="icon-profile avatar m-auto" />
            )}
          </div>
          <div className="user-information ">
            <div className="information-left">
              <p
                className={
                  this.props.friendInformation.friend ? 'd-block' : 'd-none'
                }
              >
                <span>
                  <i className="icon-check2" />
                </span>
                Friends{' '}
              </p>
              <h4>
                {this.props.friendInformation.firstName}
                {this.props.friendInformation.lastName}
              </h4>
              {this.props.friendInformation.pfeRate && (
                <p className="information">
                  {this.props.friendInformation.pfeRate}
                </p>
              )}
            </div>
            <div className="divider-line-container h-100">
              <div className="vertical-line h-100" />
            </div>
            <div className="information-right">
              <p className="header-label">STUDYING FOR</p>
              <div className="plan-information">
                <p className="information large">
                  {this.props.friendInformation.cycle}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center d-md-flex">
          <div className="earned-points-section">
            <div className="section-icon container">
              <div className="circle-icon">
                <i className="icon-star" />
              </div>
              <div className="information-icon">
                <p className="information large">
                  {this.props.friendInformation.points}
                </p>
                <p className="header-label">POINTS</p>
              </div>
            </div>
            <div className="section-icon container">
              <div className="circle-icon">
                <i className="icon-bars" />
              </div>
              <div className="information-icon">
                <p className="information large">
                  {this.props.friendInformation.level}
                </p>
                <p className="header-label">LEVEL</p>
              </div>
            </div>
            <div className="section-icon container">
              <div className="circle-icon">
                <i className="icon-trophy" />
              </div>
              <div className="information-icon">
                <p className="information large">
                  {this.props.friendInformation.badges}
                </p>
                <p className="header-label">BADGES</p>
              </div>
            </div>
          </div>
          <button className={buttonClass}>{buttonLabel}</button>
        </div>
      </div>
    );
  }
}
FriendProfileHeader.propTypes = {
  friendInformation: PropTypes.object,
  loadFriendHeader: PropTypes.func.isRequired,
};

export default FriendProfileHeader;
